var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "v-input-number", style: { width: _vm.inputWidth } },
    [
      _c(
        "div",
        {
          staticClass: "input-group--content",
          class: {
            "is-hover": _vm.isHover,
            "is-focus": _vm.isFocus,
            "is-controls": _vm.isControls && _vm.controlsPosition === "right",
            "is-disabled": _vm.isDisabled,
          },
          on: {
            mouseover: function ($event) {
              _vm.isHover = true
            },
            mouseout: function ($event) {
              _vm.isHover = false
            },
          },
        },
        [
          _vm.isControls && _vm.controlsPosition != "right"
            ? _c("v-button", {
                staticClass:
                  "v-input-number__controls v-icon-minus v-input-number__controls--left v-input--no-border",
                class: { "btn-disabled": _vm.subDisabled },
                attrs: { disabled: _vm.isDisabled, size: _vm.size },
                on: { click: _vm.subNum },
              })
            : _vm._e(),
          _c("v-input", {
            ref: "input",
            staticClass: "v-input--no-border",
            class: {
              "v-input-number__position":
                _vm.isControls && _vm.controlsPosition != "right",
            },
            attrs: {
              name: _vm.name,
              "data-name": _vm._name,
              "is-child": "",
              width: _vm.width,
              disabled: _vm.isDisabled,
              size: _vm.size,
              maxlength: _vm.inputMaxLength,
              allow: _vm.allow,
            },
            on: {
              focus: function ($event) {
                _vm.isFocus = true
              },
              blur: function ($event) {
                _vm.isFocus = false
              },
              change: _vm.handlerChange,
            },
            model: {
              value: _vm.inputValue,
              callback: function ($$v) {
                _vm.inputValue = $$v
              },
              expression: "inputValue",
            },
          }),
          _vm.isControls
            ? [
                _vm.controlsPosition !== "right"
                  ? _c("v-button", {
                      staticClass:
                        "v-input-number__controls v-icon-add v-input-number__controls--right v-input--no-border",
                      class: { "btn-disabled": _vm.addDisabled },
                      attrs: { disabled: _vm.isDisabled, size: _vm.size },
                      on: { click: _vm.addNum },
                    })
                  : [
                      _c("span", {
                        staticClass: "v-icon-up v-input-number__button up",
                        class: { "btn-disabled": _vm.addDisabled },
                        on: { click: _vm.addNum },
                      }),
                      _c("span", {
                        staticClass: "v-icon-down v-input-number__button down",
                        class: { "btn-disabled": _vm.subDisabled },
                        on: { click: _vm.subNum },
                      }),
                    ],
              ]
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }